import React from 'react'
import Select from 'react-select'
import PropTypes from 'prop-types'

const defaultOptionLabel = 'name',
  defaultOptionValue = 'id',
  noop = (event) => {},
  defaultName = '',
  defaultPlaceholder = 'Select any that apply...',
  defaultOptions = [],
  defaultId = '',
  defaultValue = [],
  defaultInvalid = false,
  defaultDisabled = false

const MultiSelect = ({
  options = defaultOptions,
  optionLabel = defaultOptionLabel,
  optionValue = defaultOptionValue,
  name = defaultName,
  placeholder = defaultPlaceholder,
  onChange = noop,
  id = defaultId,
  value = defaultValue,
  invalid = defaultInvalid,
  disabled = defaultDisabled,
  onBlur = noop,
}) => {

  const onSelectChanged = React.useCallback((selectedValues) => {
    onChange({
      target: {
        name,
        value: selectedValues,
      },
    })
  }, [ onChange, name, ])

  const onBlurred = React.useCallback(() => {
    onBlur({
      target: {
        name,
        value,
      },
    })
  }, [ onBlur, name, value, ])

  const selectStyles = {
    // Fixes the overlapping problem of the component
    // https://stackoverflow.com/questions/55830799/how-to-change-zindex-in-react-select-drowpdown
    menu      : provided => ({ ...provided, zIndex: 9999, }),
    container : provided => { 
      if (invalid) {
        return {
          ...provided, 
          borderColor  : '#dc3545', 
          borderWidth  : '1px', 
          borderStyle  : 'solid', 
          borderRadius : '4px', 
        }
      }
      return provided
    },
    placeholder: provided => ({ ...provided, color: '#757575', }),
  }

  const getOptionLabel = React.useCallback((o) => {
    return o[optionLabel]
  }, [ optionLabel, ])
  const getOptionValue = React.useCallback((o) => {
    return o[optionValue]
  }, [ optionValue, ])

  return <Select 
    options={options}
    getOptionLabel={getOptionLabel}
    getOptionValue={getOptionValue}
    isMulti={true}
    isSearchable={true}
    name={name}
    styles={selectStyles}
    onChange={onSelectChanged}
    id={id}
    value={value}
    placeholder={placeholder}
    className={`${invalid ? 'is-invalid' : ''}`}
    isDisabled={disabled}
    onBlur={onBlurred}
    aria-label={optionLabel}
  />
}

MultiSelect.propTypes = {
  options     : PropTypes.array,
  optionLabel : PropTypes.string,
  optionValue : PropTypes.string,
  name        : PropTypes.string,
  id          : PropTypes.string,
  onChange    : PropTypes.func,
  value       : PropTypes.array,
  invalid     : PropTypes.bool,
  disabled    : PropTypes.bool,
  onBlur      : PropTypes.func,
  placeholder : PropTypes.string,
}

export default MultiSelect